import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState } from 'react';
import { Button, PageEmptyState, ScrollToTopButton, Spinner } from 'seagull';
import ActivityLogItem from '~/components/ActivityLogItem/ActivityLogItem';
import RestfulWrapper from '~/components/RestfulWrapper/RestfulWrapper';
import { useStoreActions } from '~/contexts';
import { useOnMount } from '~/hooks/useOnMount';
import { useAppConfig } from '~/store/store-context';
import MinisiteTabHeader from '../MinisiteTabHeader/MinisiteTabHeader';
import ActivityErrorIcon from './icons/activity-error.svg';
function ActivityLog(props) {
    const { agreement, activityLogEntries } = props;
    const { logBI } = useStoreActions();
    const { scrollBehavior } = useAppConfig();
    const vendorName = "".concat(agreement.seller.firstName, " ").concat(agreement.seller.lastName);
    const clientName = "".concat(agreement.buyer.firstName, " ").concat(agreement.buyer.lastName);
    const containerRef = useRef(null);
    const [scrollContainer, setScrollContainer] = useState();
    useOnMount(()=>{
        logBI(10574);
        if (containerRef.current) {
            const node = containerRef.current.closest('[data-testid="minisite-page"]');
            if (node) {
                setScrollContainer(node);
            }
        }
    });
    return /*#__PURE__*/ _jsxs("div", {
        ref: containerRef,
        children: [
            /*#__PURE__*/ _jsx("div", {
                "data-testid": "activity-page-page-header",
                children: /*#__PURE__*/ _jsx(MinisiteTabHeader, {})
            }),
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        "data-testid": "activity-content",
                        children: activityLogEntries.map((logItem, idx)=>/*#__PURE__*/ _jsx(ActivityLogItem, {
                                isFirst: idx === 0,
                                isLast: idx === activityLogEntries.length - 1,
                                vendorName: vendorName,
                                clientName: clientName,
                                entry: logItem,
                                relationship: agreement
                            }, logItem.id()))
                    }),
                    /*#__PURE__*/ _jsx(ScrollToTopButton, {
                        testId: "activity-scroll-to-top-btn",
                        scrollContainer: scrollContainer,
                        scrollBehavior: scrollBehavior
                    })
                ]
            })
        ]
    });
}
export default function WrappedActivityLog(param) {
    let { agreement } = param;
    const { fetchActivityLog } = useStoreActions();
    return /*#__PURE__*/ _jsx(RestfulWrapper, {
        fetch: ()=>fetchActivityLog(agreement.id),
        getStoreLocation: (state)=>state.activityLog[agreement.id],
        renderLoader: ()=>/*#__PURE__*/ _jsx(Spinner, {
                centeredInBox: true,
                centerBoxHeight: 300
            }),
        renderChild: (param)=>{
            let { data, loading, refresh } = param;
            return /*#__PURE__*/ _jsx(ActivityLog, {
                agreement: agreement,
                activityLogEntries: data,
                isRefreshing: loading,
                refresh: refresh
            });
        },
        renderError: (param)=>{
            let { refresh } = param;
            return /*#__PURE__*/ _jsx(PageEmptyState, {
                illustration: /*#__PURE__*/ _jsx(ActivityErrorIcon, {}),
                message: "Couldn't load the activity log",
                actions: /*#__PURE__*/ _jsx(Button, {
                    onClick: ()=>refresh(),
                    testId: "activity-error-refresh-btn",
                    children: "Try again"
                })
            });
        }
    });
}
